import { useQuery } from '@tanstack/react-query';
import { apiGet } from 'src/lib/api/axios';
import { CategoryDefaultsResponse } from '../types';
import useActiveTenantRole from 'src/hooks/useActiveTenantRole';

export const CATEGORY_DEFAULTS_QUERY_KEY = ['categoryDefaults'];

/**
 * Fetches every category accessible to the current user plus a boolean flag
 * indicating whether it is enabled by default in the chat filter.
 *
 * Returns `Record<string, boolean>`, e.g. `{ "Guidance": true, "Best Practices": false }`.
 * Callers that only need the default-enabled names can filter with
 * `Object.entries(data).filter(([, v]) => v).map(([k]) => k)`.
 */
export const useCategoryDefaults = () => {
  const { isStandardMember } = useActiveTenantRole();

  return useQuery({
    queryKey: CATEGORY_DEFAULTS_QUERY_KEY,
    queryFn: async (): Promise<Record<string, boolean>> => {
      const response = await apiGet<CategoryDefaultsResponse>('docs/category-defaults', {
        meta: {
          globalError: false,
          context: 'category-defaults-fetch'
        }
      });
      return response.data.categories;
    },
    enabled: isStandardMember,
    staleTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false
  });
};
